import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Box } from '@chakra-ui/react';
import Logo from '../logo';
import styles from './radial.module.scss';
export var RadialLayout = function RadialLayout(props) {
  return /*#__PURE__*/_jsx(Box, {
    minH: "100vh",
    py: "12",
    px: {
      base: '4',
      lg: '8'
    },
    className: styles.wrapper,
    children: /*#__PURE__*/_jsxs(Box, {
      maxW: "xl",
      mx: "auto",
      children: [/*#__PURE__*/_jsx(Box, {
        h: "8",
        mb: {
          base: '10',
          md: '20'
        },
        children: /*#__PURE__*/_jsx(Logo, {
          withText: true
        })
      }), props.children]
    })
  });
};
export default RadialLayout;